import { array, func, object, oneOf } from 'prop-types'
import { kuiperClassNames } from '../../utils'
import Filter from '../Filter'
import BucketHeader from './BucketHeader'

import './styles.scss'

const ActiveFilters = ({
  disabledValues = [],
  filters = [],
  filterValues = {},
  onChange,
  onDisableFilter,
  onFilterRemove,
  theme = 'light',
  value,
}) => (
  <div className={kuiperClassNames('active-filters')}>
    {filters
      .filter((filter) => value.indexOf(filter.id) > -1)
      .map((filter) => filter.ancestors[0])
      .reduce(
        (buckets, bucket) =>
          buckets.indexOf(bucket) < 0 ? [...buckets, bucket] : buckets,
        []
      )
      .map((bucket) => [
        bucket ? (
          <BucketHeader
            key={bucket.id}
            inclusivity={filterValues.inclusivity}
            onOperationChange={(newValue) => onChange('inclusivity', newValue)}
            theme={theme}
            {...bucket}
          />
        ) : null,
        ...filters
          .filter((filter) => value.indexOf(filter.id) > -1)
          .filter((filter) => filter.ancestors[0] === bucket)
          .map((filter) => (
            <Filter
              key={filter.id}
              disabled={disabledValues.includes(filter.id)}
              isDisableable={true}
              isRemovable={true}
              onChange={onChange}
              onDisable={onDisableFilter.bind(this, filter.id)}
              onMouseMove={() => {}}
              onRemove={onFilterRemove.bind(this, filter.id)}
              selected={true}
              theme={theme}
              value={filterValues[filter.id]}
              {...filter}
            />
          )),
      ])}
    {value.length ? undefined : (
      <div className={kuiperClassNames('no-filters')}>Select filters above</div>
    )}
  </div>
)
ActiveFilters.displayName = 'Kuiper: ActiveFilters ← FilterBar '

ActiveFilters.propTypes = {
  disabledValues: array,
  filters: array,
  filterValues: object,
  onChange: func,
  onDisableFilter: func,
  onFilterRemove: func,
  theme: oneOf(['dark', 'light']),
  value: array,
}

export default ActiveFilters
